import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { Observable } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { select } from '@ngxs/store';

import { AuthState } from '@dis/auth';
import { LayoutState } from '@dis/shared';

import { CastMode } from '../../../core/routing/cast-mode';
import { SidenavService } from '../sidenav/sidenav.service';

import { ActivePressureTestComponent } from '../../../ui/active-pressure-test/active-pressure-test.component';
import { HeaderSearch } from '../header-search/header-search';
import { ViewScopeSelect } from '../view-scope-select/view-scope-select';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    NgOptimizedImage,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatTooltipModule,
    RouterLink,
    ActivePressureTestComponent,
    HeaderSearch,
    ViewScopeSelect,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  isHandset = select(LayoutState.isHandset);

  pressureTest$: Observable<any> | undefined;

  sidenavService = inject(SidenavService);

  protected readonly castMode = inject(CastMode);

  user = select(AuthState.claims);
}
